import React from 'react';
import { Box } from '@mui/material';

const Tag = ({ children }) => {
  return (
    <Box
      component="span"
      sx={{
        fontSize: '10px',
        fontFamily: 'mono',
        px: 1.5,
        py: 0.5,
        bgcolor: 'custom.white5',
        border: '1px solid',
        borderColor: 'custom.white10',
        borderRadius: 1,
        color: 'text.secondary',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
      }}
    >
      {children}
    </Box>
  );
};

export default Tag;